import { useCallback, useContext, useState } from "react";
import { AuthContext, GroupOwnerContext } from "../../../contexts";
// import Enrollment from "./Enrollment";
import DynamicEnrollment from "./DynamicEnrollment";
import IntercityEnrollment from "./IntercityInvestments/IntercityEnrollment";

import { GROUP_NUMBER } from "../../../constants/groups";
import BOPEnrollment from "./PanhandleFirstBankBOP/BOPEnrollment";
import ProgressiveLaboratories from "./ProgressiveLabs/ProgressiveLaboratories";
import TestGroupPlan from "./TestGroup/TestGroup";
import Enrollment from "./Enrollment";
import CircularLoader from "../../shared/loader/CircularLoader";

const MasterEnrollments = (): JSX.Element => {
	const { member } = useContext(AuthContext);
	const { groupOwner } = useContext(GroupOwnerContext);
	const permission = (groupOwner as any)?.permissions.find(
		(group: any) => group.group_number === member?.group_number
	)["permission_and_subscription"]?.permissions?.employer_members_menu.self.members_list_table.member_details_view;
	const [isLoading, setIsLoading] = useState(true);
	// console.log("member-group-number: ", member?.group_number);
	const handleLoadingComplete = useCallback(() => {
		setIsLoading(false);
	}, []);
	return (
		<>
			{!permission || permission.core_benefits_tab.view ? (
				<>
					{/* {member?.group_number === GROUP_NUMBER.BBI_BROOKSHIRE_BROTHERS ? (
						<Enrollment />
					) : member?.group_number === GROUP_NUMBER.ICI_INTERCITY_INVESTMENTS ? (
						<IntercityEnrollment />
					) : member?.group_number === GROUP_NUMBER.BOP_PANHANDLE_FIRST_BANK ? (
						<BOPEnrollment />
					) : member?.group_number === GROUP_NUMBER.PROGRESSIVE_LABORATORIES ? (
						<ProgressiveLaboratories />
					) : member?.group_number === GROUP_NUMBER.TEST_GROUP ? (
						<TestGroupPlan />
					) : (
						<></>
					)} */}

					{isLoading && (
						<div className="loader-container">
							<CircularLoader />
						</div>
					)}
					<DynamicEnrollment onInitComplete={handleLoadingComplete} />
				</>
			) : null}
		</>
	);
};

export default MasterEnrollments;
